// Mêmes helpers que Client/js/app.js (apiFetch/extraireErreurApi) — même serveur,
// même contrat d'API. Le jeton vient du store Pinia au lieu de `this.sessionToken`.
import { useAuthStore } from '@/stores/auth'

export const API_BASE = 'https://api.alexismayeur.fr:3001'

export async function apiFetch(url, options = {}) {
  const auth = useAuthStore()
  const headers = { ...(options.headers || {}) }
  if (auth.sessionToken) headers.Authorization = `Bearer ${auth.sessionToken}`
  return fetch(url, { ...options, headers })
}

export async function extraireErreurApi(res) {
  try {
    const body = await res.json()
    return body.details || body.error || `HTTP ${res.status}`
  } catch {
    return `HTTP ${res.status}`
  }
}

export function formatDateFr(iso) {
  return new Date(iso + 'T00:00:00').toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function formatDateHeureFr(dateSql) {
  return new Date(dateSql.replace(' ', 'T')).toLocaleString('fr-FR', {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  })
}

// Date du jour au format YYYY-MM-DD en heure locale (pas toISOString, qui bascule sur UTC et
// peut donner la mauvaise date selon l'heure) — pré-remplit les champs date "ponctuel".
export function dateIsoAujourdhui() {
  const d = new Date()
  const mois = String(d.getMonth() + 1).padStart(2, '0')
  const jour = String(d.getDate()).padStart(2, '0')
  return `${d.getFullYear()}-${mois}-${jour}`
}
